/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unknown_CompanyInputs */

const en_unknown_company = /** @type {(inputs: Unknown_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown company`)
};

const de_unknown_company = /** @type {(inputs: Unknown_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekanntes Unternehmen`)
};

/**
* | output |
* | --- |
* | "Unknown company" |
*
* @param {Unknown_CompanyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const unknown_company = /** @type {((inputs?: Unknown_CompanyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unknown_CompanyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_unknown_company(inputs)
	return en_unknown_company(inputs)
});